<template>
  <div class="sidebar-profile">
        <div class="avatar">
            <img class="img-circle profile-image" :src="$store.state.user.avatar" alt="profile">
        </div>
        <div class="profile-body dropdown">
            <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                <h4>{{ $store.state.user.userName }}<span class="caret"></span></h4>
            </a>
            <small class="title">{{ $store.state.user.userRole }}</small>
            <ul class="dropdown-menu animated fadeInRight" role="menu">
                <li class="profile-progress">
                    <h5>
                        <span>80%</span>
                        <small>Profile complete</small>
                    </h5>
                    <div class="progress progress-xs">
                        <div class="progress-bar progress-bar-primary" style="width: 80%">
                        </div>
                    </div>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="javascript:void(0);">
                        <span class="icon"><i class="fa fa-user"></i>
                        </span>My Account</a>
                </li>
                <li>
                    <a href="javascript:void(0);">
                        <span class="icon"><i class="fa fa-envelope"></i>
                        </span>Messages</a>
                </li>
                <li>
                    <a href="javascript:void(0);">
                        <span class="icon"><i class="fa fa-cog"></i>
                        </span>Settings</a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="javascript:void(0);">
                        <span class="icon"><i class="fa fa-sign-out"></i>
                        </span>Logout</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'profile-block',
        data() {
            return {
                username: "mrDelfs"
            }
        }
    }
</script>

<style>

</style>


